import { UserFormState } from "../components";
import { apiService, Endpoints } from "api";

export const createUser = async (values: UserFormState) => {
  await apiService.post(Endpoints.Users.Post.Create, {
    ...values,
    email: values.email.toLowerCase(),
  });
};
